import React, { FunctionComponent } from 'react';
import { Formik, FormikHelpers as FormikActions } from 'formik';
import { MixedSchema } from 'yup';
import Flex from 'components/Flex';
import Button from 'components/Button';
import PhoneField from 'components/Form/PhoneInput/FormikField';
import Field from 'components/Form/Field';
import LocationField from 'components/Form/Location/FormikField';

export interface IProps {
  initialValues: IFormValues;
  validationSchema?: MixedSchema;
  onSubmit: (values: IFormValues, actions: FormikActions<IFormValues>) => void;
}

export interface IFormValues {
  is_location_confirmed: boolean;
  cell_num: string;
  phone_number: string;
  first_name: string;
  last_name: string;
  location: {
    postcode: string;
    address: string;
    apartment: string;
    city: {
      title: string;
      id?: string;
    };
    region: {
      title: string;
      short_code: string;
    };
    country: {
      title: string;
      short_code: string;
    };
  };
}

const Form: FunctionComponent<IProps> = ({ initialValues, validationSchema, onSubmit }: IProps) => (
  <Formik<IFormValues>
    onSubmit={onSubmit}
    validationSchema={validationSchema}
    initialValues={initialValues}
  >
    {({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <Field
          name="location"
          component={LocationField}
          className="mt8"
          label="Address"
          placeholder="Search your address..."
          initValue={initialValues.location?.address}
          needApartment
        />
        <Field
          name="first_name"
          label="First name"
          placeholder="First name"
          className="mt8"
          data-lpignore="true"
        />
        <Field
          name="last_name"
          label="Last name"
          placeholder="Last name"
          className="mt8"
          data-lpignore="true"
        />
        <PhoneField
          name="cell_num"
          label="Mobile phone number"
          className="mt8"
          data-lpignore="true"
        />
        <PhoneField name="phone_number" label="Phone number" className="mt8" data-lpignore="true" />
        <Flex justifyContent="center" className="mt48">
          <Button type="submit">Confirm</Button>
        </Flex>
      </form>
    )}
  </Formik>
);

export default Form;
